import React, { createContext, useContext, useEffect, useState } from 'react';
import { lightTheme, darkTheme } from './tokens';

const ThemeContext = createContext({ theme: lightTheme, mode: 'light', setMode: () => {} });

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
    localStorage.setItem('theme', mode);
  }, [mode]);

  const theme = mode === 'dark' ? darkTheme : lightTheme;
  return <ThemeContext.Provider value={{ theme, mode, setMode }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
